import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { UserIcon, PhoneIcon, CalendarIcon, SaveIcon, QrCodeIcon } from 'lucide-react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Badge } from '../../components/ui/Badge';
import { useAuth } from '../../lib/AuthContext';
import { formatPhone, formatDate, getTierNameVi } from '../../lib/formatters';
export function ProfilePage() {
  const {
    currentCustomer,
    isCustomerLoggedIn,
    updateCustomer
  } = useAuth();
  const [name, setName] = useState(currentCustomer?.name || '');
  const [dob, setDob] = useState(currentCustomer?.dateOfBirth || '');
  const [gender, setGender] = useState(currentCustomer?.gender || '');
  const [saved, setSaved] = useState(false);
  if (!isCustomerLoggedIn || !currentCustomer) {
    return <div className="max-w-4xl mx-auto px-4 py-16 text-center" data-id="element-1512">
        <UserIcon className="w-16 h-16 text-[#666666] mx-auto mb-4" data-id="element-1513" />
        <h2 className="text-xl font-semibold text-white mb-2" data-id="element-1514">
          Vui lòng đăng nhập
        </h2>
      </div>;
  }
  const handleSave = () => {
    updateCustomer({
      name,
      dateOfBirth: dob || undefined,
      gender: gender as 'male' | 'female' | 'other' || undefined
    });
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };
  return <div className="max-w-2xl mx-auto px-4 py-8" data-id="element-1515">
      <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} data-id="element-1516">
        <h1 className="text-2xl font-bold text-white mb-6 flex items-center gap-3" data-id="element-1517">
          <UserIcon className="w-7 h-7 text-[#C8A84E]" data-id="element-1518" />
          Hồ Sơ Cá Nhân
        </h1>
      </motion.div>

      {/* QR Membership Card */}
      <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.05
    }} data-id="element-1519">
        <Card className="mb-6" data-id="element-1520">
          <div className="flex flex-col sm:flex-row items-center gap-6" data-id="element-1521">
            <div className="w-32 h-32 bg-white rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-1522">
              <div className="w-28 h-28 bg-[#0D0D0D] rounded-lg flex flex-col items-center justify-center p-2" data-id="element-1523">
                <QrCodeIcon className="w-12 h-12 text-[#C8A84E] mb-1" data-id="element-1524" />
                <span className="text-[8px] text-[#C8A84E] font-mono" data-id="element-1525">
                  {currentCustomer.referralCode}
                </span>
              </div>
            </div>
            <div className="text-center sm:text-left" data-id="element-1526">
              <h2 className="text-lg font-bold text-white" data-id="element-1527">
                {currentCustomer.name || 'Thành viên MHP'}
              </h2>
              <p className="text-sm text-[#B0B0B0]" data-id="element-1528">
                {formatPhone(currentCustomer.phone)}
              </p>
              <div className="flex items-center gap-2 mt-2 justify-center sm:justify-start" data-id="element-1529">
                <Badge variant="tier" tier={currentCustomer.tier} size="md" data-id="element-1530">
                  {getTierNameVi(currentCustomer.tier)}
                </Badge>
                <span className="text-xs text-[#666666]" data-id="element-1531">
                  Thành viên từ {formatDate(currentCustomer.createdAt)}
                </span>
              </div>
              <p className="text-xs text-[#666666] mt-2" data-id="element-1532">
                Xuất trình mã QR tại quầy để tích điểm
              </p>
            </div>
          </div>
        </Card>
      </motion.div>

      {/* Edit Profile */}
      <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.1
    }} data-id="element-1533">
        <Card title="Thông Tin Cá Nhân" data-id="element-1534">
          <div className="space-y-4" data-id="element-1535">
            <Input label="Số điện thoại" value={formatPhone(currentCustomer.phone)} disabled leftIcon={<PhoneIcon className="w-4 h-4" data-id="element-1537" />} hint="Không thể thay đổi" data-id="element-1536" />
            <Input label="Họ và tên" value={name} onChange={e => setName(e.target.value)} placeholder="Nguyễn Văn A" leftIcon={<UserIcon className="w-4 h-4" data-id="element-1539" />} data-id="element-1538" />
            <Input label="Ngày sinh" type="date" value={dob} onChange={e => setDob(e.target.value)} leftIcon={<CalendarIcon className="w-4 h-4" data-id="element-1541" />} data-id="element-1540" />
            <div data-id="element-1542">
              <label className="block text-sm font-medium text-[#B0B0B0] mb-1.5" data-id="element-1543">
                Giới tính
              </label>
              <div className="flex gap-3" data-id="element-1544">
                {[{
                value: 'male',
                label: 'Nam'
              }, {
                value: 'female',
                label: 'Nữ'
              }, {
                value: 'other',
                label: 'Khác'
              }].map(opt => <button key={opt.value} onClick={() => setGender(opt.value)} className={`flex-1 py-2 text-sm font-medium rounded-lg border transition-colors ${gender === opt.value ? 'border-[#C8A84E] bg-[#C8A84E]/10 text-[#C8A84E]' : 'border-[#2A2A2A] text-[#B0B0B0] hover:border-[#333333]'}`} data-id="element-1545">
                    {opt.label}
                  </button>)}
              </div>
            </div>
            <Button onClick={handleSave} fullWidth data-id="element-1546">
              <SaveIcon className="w-4 h-4" data-id="element-1547" />
              {saved ? 'Đã Lưu!' : 'Lưu Thay Đổi'}
            </Button>
          </div>
        </Card>
      </motion.div>
    </div>;
}